














import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { i18n } from "@/resources/locales";
@Component({
  name: "next-maintenance-component",
})
export default class NextMaintenanceComponent extends Vue {
  date = "";
  notification = null;
  mounted() {
    this.timeNextMaintenance();
  }
  destroyed(): void {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
    if (this.notification) this.notification.close();
  }
  timeNextMaintenance() {
    let date = "";
    const timestamp =
      this.$store.getters["FloatMenuStore/getTimeNextMaintenance"];
    const formatLocale =
      i18n.locale === "en" ? "hh:mm a, MM/DD/YYYY" : "hh:mm a, DD/MM/YYYY";
    if (timestamp) {
      date = moment(parseInt(timestamp) * 1000)
        .utc()
        .local()
        .format(formatLocale);
    }
    this.date = date;
    this.showNotification();
  }
  getText() {
    return i18n.t("notifications.warningMessages.nextMaintenance", {
      date: this.date,
    });
  }
  showNotification(): void {
    this.notification = this.$vs.notification({
      sticky: true,
      buttonClose: true,
      duration: "none",
      position: "top-right",
      color: "rgb(43,61,142)",
      text: `<pre class="text-pre-12">${i18n.t(
        "notifications.warningMessages.nextMaintenance",
        {
          date: this.date,
        }
      )}</pre>`,
    });
  }
}
